(() => {
  const dialog = document.getElementById('MarlenSearch');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const input = dialog.querySelector('[name="q"]');
  const results = dialog.querySelector('#MarlenSearchResults');
  const status = dialog.querySelector('.ms-status');
  const defaults = dialog.querySelector('template');
  let timer, controller, revision = 0, opener, oldOverflow;
  const reset = () => results.replaceChildren(defaults.content.cloneNode(true));
  const cancel = () => { clearTimeout(timer); controller?.abort(); revision++; results.removeAttribute('aria-busy'); };
  document.querySelectorAll('[data-open-search]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault(); opener = link; reset(); status.textContent = ''; input.value = '';
    oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    dialog.showModal(); input.focus();
  }));
  dialog.querySelector('[data-close-search]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { cancel(); document.body.style.overflow = oldOverflow; opener?.focus(); });
  input.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { const first = results.querySelector('a'); if (first) { event.preventDefault(); first.focus(); } } });
  input.addEventListener('input', () => {
    cancel(); const query = input.value.trim(); const current = revision;
    if (!query) { status.textContent = ''; reset(); return; }
    results.replaceChildren(); results.setAttribute('aria-busy', 'true'); status.textContent = 'جاري البحث…';
    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(dialog.querySelector('form').action);
      url.search = new URLSearchParams({ q: query, type: 'product', 'options[prefix]': 'last', section_id: 'search-suggestions' });
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = parsed.querySelector('[data-search-response]');
        if (!content) throw new Error('Missing search section');
        if (current !== revision || !dialog.open) return;
        results.replaceChildren(content); status.textContent = content.dataset.resultCount + ' نتيجة';
      } catch (error) {
        if (error.name === 'AbortError' || current !== revision) return;
        status.textContent = 'تعذر تحميل الاقتراحات. اضغطي بحث لعرض النتائج.';
      } finally { if (current === revision) results.removeAttribute('aria-busy'); }
    }, 220);
  });
})();
